"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'project.form.title.edit': 'Editar proyecto',
    'project.form.title.add': 'Agregar proyecto',
    'project.form.back': 'Atrás',
    'project.form.color.placeholder': '#007bff',
    'project.form.icon.placeholder': 'fas fa-folder',
};
